import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ANSWERS_DATA } from "./quizData";

function QuizeCheck({ answerData, onWrong }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  // 문자열 정규화 (공백 제거 + 소문자)
  const normalize = (str) => str.replace(/\s+/g, "").toLowerCase();

  const handleSubmit = () => {
    const QUIZ = ANSWERS_DATA[answerData];

    // q1, q2 자체가 없을 때
    if (!QUIZ) {
      onWrong?.();
      return;
    }

    const input = normalize(value);

    // answer를 항상 배열로 변환
    const answers = Array.isArray(QUIZ.answer) ? QUIZ.answer : [QUIZ.answer];

    // 정답 비교
    const isCorrect = answers.some((ans) => normalize(ans) === input);

    if (!isCorrect) {
      onWrong?.();
      return;
    }

    // ✅ 정답 → 다음 페이지 이동
    navigate("/answer", {
      state: {
        answerDataState: QUIZ.next.answerData,
        DateValState: QUIZ.next.DateVal,
        titImgclassNameState: QUIZ.next.titImgclassName,
        hintWhetherIsState: QUIZ.next.hintWhetherIs,
        hintContentState: QUIZ.next.hintContent,
        countingState: QUIZ.next.counting,
        missionKeyState: QUIZ.next.missionKey,
      },
    });
  };

  return (
    <div className="mt24 mb40">
      <input
        className="input01"
        placeholder="키워드를 입력하세요."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") handleSubmit();
        }}
      />

      <button className="inputBtn02 mt16" onClick={handleSubmit}>
        입력 완료
      </button>
    </div>
  );
}

export default QuizeCheck;
